import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { clearBulkOrderCatalogCartRemapNotice } from '../../common/bulkOrder'
import * as notifs from '../../common/lib/notifs'

const useBulkOrderCatalogCartNotice = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const notice = useSelector(state => state.bulkOrder.catalogCartRemapNotice)

  useEffect(() => {
    if (!notice) return

    if (notice.droppedCount > 0) {
      notifs.warning({ title: t('BULK_ORDER_CATALOG_CART_LINES_DROPPED') })
    }

    dispatch(clearBulkOrderCatalogCartRemapNotice())
  }, [dispatch, notice, t])
}

export default useBulkOrderCatalogCartNotice
